import React from 'react';
import ForgotPassword from '../components/ForgotPasswordComponent/ForgotPassword';

function ForgotPasswordPage() {
  return (
    <div>
      <ForgotPassword />
    </div>
  );
}

export default ForgotPasswordPage;
